









































































































































































import Company from "@/model/company";
import ContractMoveOut, { CONTRACT_STEP } from "@/model/contractMoveOut";
import ContractSignature from "@/model/contractSignature";
import User from "@/model/user";
import { Component, Prop, Vue } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import QSignature from "@/common/qSignature.vue";
import { cloneDeep } from "lodash";
import { namespace } from "vuex-class";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import postalCodeApi from "@/api/postalCodeApi";
import Location from "@/model/location";
import qNotify from "@/common/qNotify";
import { v4 as uuidv4 } from "uuid";
import VueScrollTo from "vue-scrollto";
import fileApi from "@/api/fileApi";
const routerStore = namespace("Router");
const auth = namespace("Auth");
const moveOutStore = namespace("MoveOut");
@Component({
  name: "StepSignature",
  components: {
    StepCheckList,
    QErrors,
    QSignature,
  },
})
export default class StepSignature extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;
  @routerStore.Getter
  public getSearchParameters!:any;

  @Prop({ default: false })
  reSign: boolean;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();

  public objectSignature: ContractSignature = new ContractSignature();

  public showPopup = false;
  public errors = {};

  mounted() {
    this.moveOutObject = new ContractMoveOut(cloneDeep(this.getMoveOut));
    if (!this.moveOutObject.contract_signature) {
      this.moveOutObject.contract_signature = new ContractSignature();
    }
    this.objectSignature = this.moveOutObject.contract_signature;
    this.objectSignature.re_sign = this.reSign;
    if (this.objectSignature.bank_account_information == null) {
      this.objectSignature.bank_account_information = this.moveOutObject.contract.bank_account_information;
    }
    if (this.objectSignature.zip_code == null && this.moveOutObject.zip_code) {
      this.objectSignature.zip_code = this.moveOutObject.zip_code;
      this.objectSignature.location = new Location(this.moveOutObject.location);
      this.objectSignature.exact_address = this.moveOutObject.exact_address;
      this.objectSignature.phone = this.moveOutObject.phone_number;
    } else {
      this.objectSignature.location = new Location(
        this.objectSignature.location
      );
    }
    this.$nextTick(() => {
      const { clientWidth, clientHeight } = this.$refs.signatureArea as Element;

      (this.$refs.freeDraw as QSignature).show({
        width: clientWidth - 10,
        height: clientHeight - 10,
      });
    });
  }

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  public async getPostalCode() {
    if (this.objectSignature.zip_code.trim() === "") {
      this.objectSignature.location = new Location();
      this.errors = {};
      return;
    }

    const result = await postalCodeApi.show(this.objectSignature.zip_code);
    if (result) {
      this.objectSignature.location = result;
      this.errors = {};
    } else {
      this.objectSignature.location = new Location();
      this.errors = {
        zip_code: [this.$t("common.zip_code_not_found")],
      };
    }
  }

  public async uploadImageSVG(file) {
    let formData = new FormData();
    formData.append("image", file);
    formData.append("image_type", "Signature");
    const result = await fileApi.uploadImage(formData);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t(result.meta.message),
      });
    } else {
      this.objectSignature.sign_image_id = result.data.id;
    }
  }

  public async submit() {
    const canvasObject = (this.$refs.freeDraw as QSignature).export();
    if (canvasObject.object.objects.length === 0) {
      qNotify.error({
        text: this.$t("contractMoveOuts.must_be_sign"),
      });
      this.errors = {
        ...this.errors,
        sign: [this.$t("contractMoveOuts.must_be_sign")],
      };
    } else {
      await this.uploadImageSVG(canvasObject.file);
      let message = `チェックリスト作成お疲れ様でした。<br>
                契約者様へ退去精算依頼書を送信します。<br>
                管理会社・オーナー・立会業者の各担当者様へ退去精算依頼書およびチェックリスト確認書を送信します。`;
      if (this.objectSignature.re_sign) {
        message = `契約者様・管理会社様・オーナー様・立会業者様へ再署名いただいた内容で退去精算依頼書を送信します。`;
      }
      this.$modal.show({
        title: this.reSign ? "再署名完了" : "チェックリスト作成完了",
        text: message,
        confirmText: "はい",
        cancelText: this.reSign ? "いいえ" : "キャンセル",
        confirmClass: "mb__button mb__w-100pc mb__add-color-green",
        cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
        type: "",
        // we are passing callback method for our confirm button
        onConfirm: async () => {
          const result = await this.moveOutObject.signature();
          if (result.meta.status === 200) {
            // return
            qNotify.success({
              text: this.$t("contractMoveOuts.success_step_4"),
            });
            this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
          } else {
            qNotify.error({
              text: result.meta.message,
            });
            this.errors = result.meta.errors;
          }
        },
        onClose: () => {
          this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
        }
      });
    }
  }

  public async goBack() {
    const result = await this.moveOutObject.goBack({
      step: CONTRACT_STEP.STEP_CHECKLIST,
    });
    if (result.meta.status === 200) {
      this.$router.replace({ query: { step: uuidv4() } });
      VueScrollTo.scrollTo({ force: true });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }
}
